import styled from 'styled-components';

export const WaveWrapper = styled.div`
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: -1;
`;
export const BodyWaveWrapper = styled.div`
    position: relative;
    top: 0;
    right: 0;
`;
